/* eslint-disable */

let p: any; // shortcut to reference prototypes
let lib: any = {};
let ss: any = {};
let img: any = {};
lib.webFontTxtInst = {};
let loadedTypekitCount = 0;
let loadedGoogleCount = 0;
let gFontsUpdateCacheList: any[] = [];
let tFontsUpdateCacheList: any[] = [];
lib.ssMetadata = [];

export const destroyWheel = () => {
  p = null;
  lib = {};
  ss = {};
  img = {};
  loadedTypekitCount = 0;
  loadedGoogleCount = 0;
  gFontsUpdateCacheList = [];
  tFontsUpdateCacheList = [];
};

export const initWheel = function (cjs: any, an: any, exportRoot: any) {

  lib.updateListCache = function (cacheList: any[]) {
  	for(var i = 0; i < cacheList.length; i++) {
  		if(cacheList[i].cacheCanvas)
  			cacheList[i].updateCache();
  	}
  };

  lib.addElementsToCache = function (textInst: any, cacheList: any[]) {
  	var cur = textInst;
  	while(cur != null && cur != exportRoot) {
  		if(cacheList.indexOf(cur) != -1)
  			break;
  		cur = cur.parent;
  	}
  	if(cur != exportRoot) {
  		var cur2 = textInst;
  		var index = cacheList.indexOf(cur);
  		while(cur2 != null && cur2 != cur) {
  			cacheList.splice(index, 0, cur2);
  			cur2 = cur2.parent;
  			index++;
  		}
  	}
  	else {
  		cur = textInst;
  		while(cur != null && cur != exportRoot) {
  			cacheList.push(cur);
  			cur = cur.parent;
  		}
  	}
  };

  lib.gfontAvailable = function(family: any, totalGoogleCount: any) {
  	lib.properties.webfonts[family] = true;
  	var txtInst = lib.webFontTxtInst && lib.webFontTxtInst[family] || [];
  	for(var f = 0; f < txtInst.length; ++f)
  		lib.addElementsToCache(txtInst[f], gFontsUpdateCacheList);

  	loadedGoogleCount++;
  	if(loadedGoogleCount == totalGoogleCount) {
  		lib.updateListCache(gFontsUpdateCacheList);
  	}
  };

  lib.tfontAvailable = function(family: any, totalTypekitCount: any) {
  	lib.properties.webfonts[family] = true;
  	var txtInst = lib.webFontTxtInst && lib.webFontTxtInst[family] || [];
  	for(var f = 0; f < txtInst.length; ++f)
  		lib.addElementsToCache(txtInst[f], tFontsUpdateCacheList);

  	loadedTypekitCount++;
  	if(loadedTypekitCount == totalTypekitCount) {
  		lib.updateListCache(tFontsUpdateCacheList);
  	}
  };
  // symbols:
  // helper functions:

  function mc_symbol_clone() {
  	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
  	clone.gotoAndStop(this.currentFrame);
  	clone.paused = this.paused;
  	clone.framerate = this.framerate;
  	return clone;
  }

  function getMCSymbolPrototype(symbol: any, nominalBounds: any, frameBounds: any) {
  	var prototype = cjs.extend(symbol, cjs.MovieClip);
  	prototype.clone = mc_symbol_clone;
  	prototype.nominalBounds = nominalBounds;
  	prototype.frameBounds = frameBounds;
  	return prototype;
  	}


  (lib.Symbol8 = function(mode: any, startPosition: any, loop: any) {
  	this.initialize(mode,startPosition,loop,{});

  	// Layer 1
  	this.shape = new cjs.Shape();
  	this.shape.graphics.f("#FFFFFF").s().p("AgRASQgHgIAAgKQAAgJAHgHQAIgIAJAAQAKAAAIAIQAHAHAAAJQAAAKgHAIQgIAHgKAAQgJAAgIgHg");
  	this.shape.setTransform(39.2,60.6);

  	this.shape_1 = new cjs.Shape();
  	this.shape_1.graphics.f("#FFFFFF").s().p("AgQASQgIgIAAgKQAAgJAIgHQAHgIAJAAQAKAAAIAIQAHAHAAAJQAAAKgHAIQgIAHgKAAQgJAAgHgHg");
  	this.shape_1.setTransform(71.4,60.6);

  	this.shape_2 = new cjs.Shape();
  	this.shape_2.graphics.f("#FFFFFF").s().p("AgRASQgHgIAAgKQAAgKAHgGQAIgIAJAAQALAAAHAIQAHAGAAAKQAAAKgHAIQgHAHgLAAQgJAAgIgHg");
  	this.shape_2.setTransform(45.3,41.6);

  	this.shape_3 = new cjs.Shape();
  	this.shape_3.graphics.f("#FFFFFF").s().p("AgRARQgHgHAAgKQAAgJAHgIQAIgHAJAAQAKAAAIAHQAHAIAAAJQAAAKgHAHQgIAIgKAAQgJAAgIgIg");
  	this.shape_3.setTransform(55.1,72.6);

  	this.shape_4 = new cjs.Shape();
  	this.shape_4.graphics.f("#FFFFFF").s().p("AgQASQgIgIAAgKQAAgKAIgGQAGgIAKAAQAKAAAIAIQAHAGAAAKQAAAKgHAIQgIAHgKAAQgKAAgGgHg");
  	this.shape_4.setTransform(65,41.6);

  	this.shape_5 = new cjs.Shape();
  	this.shape_5.graphics.f("#A5A4A4").s().p("AknEoQh7h7AAitQAAisB7h7QB7h7CsAAQCtAAB7B7QB7B7AACsQABCth7B7Qh7B7iuAAQisAAh7h7gAkHkHQhuBuAACZQAACbBuBuQBtBtCaAAQCaAABuhuQBuhuAAiaQAAiZhuhuQhuhuiaAAQiZAAhuBug");
  	this.shape_5.setTransform(55.1,55.6);

  	this.shape_6 = new cjs.Shape();
  	this.shape_6.graphics.f("#FFFFFF").s().p("AiSBwQgFAAgCgEQgDgEAAgFQABgFAEgCQAEgDAEABQBjAQBQg5QBSg5AQhiQABgFAEgCQAEgDAEABQAFABACADQADAEgBAFQgSBqhZBAQhDAwhQAAQgYAAgYgEg");
  	this.shape_6.setTransform(67.4,72.3);

  	this.shape_7 = new cjs.Shape();
  	this.shape_7.graphics.f("#FFFFFF").s().p("AiTB1QgEgBgDgEQgDgEABgEQAShrBahAQBYg/BsATQAEABADADQADAEgBAFQAAAEgFADQgEADgEgBQhigRhRA6QhRA5gRBiQgCAKgJAAIgDAAg");
  	this.shape_7.setTransform(42.8,38.7);

  	this.shape_8 = new cjs.Shape();
  	this.shape_8.graphics.f("#FFFFFF").s().p("AgwAyQgVgVAAgdQAAgcAVgUQAUgVAcAAQAdAAAVAVQAUAUAAAcQAAAdgUAVQgVAUgdAAQgcAAgUgUg");
  	this.shape_8.setTransform(55.2,55.6);

  	this.shape_9 = new cjs.Shape();
  	this.shape_9.graphics.f("#BCBEC0").s().p("Ahah2IECC8IgPAwIlAABg");
  	this.shape_9.setTransform(30.5,43.4);

  	this.shape_10 = new cjs.Shape();
  	this.shape_10.graphics.f("#BCBEC0").s().p("AiXB2IgQgwIEDi8IBMDtg");
  	this.shape_10.setTransform(79.9,43.4);

  	this.shape_11 = new cjs.Shape();
  	this.shape_11.graphics.f("#BCBEC0").s().p("AiViIIAogfIEDC7IjKCUg");
  	this.shape_11.setTransform(73.4,78.4);

  	this.shape_12 = new cjs.Shape();
  	this.shape_12.graphics.f("#BCBEC0").s().p("AiVAUIEDi7IAoAfIhiEwg");
  	this.shape_12.setTransform(37.1,78.4);

  	this.shape_13 = new cjs.Shape();
  	this.shape_13.graphics.f("#BCBEC0").s().p("AgYCYIhkkvID5AAIhkEvg");
  	this.shape_13.setTransform(55.3,31.3);

  	this.shape_14 = new cjs.Shape();
  	this.shape_14.graphics.f("#BCBEC0").s().p("AhNBOQggghAAgtQAAgtAgggQAgggAtAAQAuAAAgAgQAgAgAAAtQAAAtggAhQghAggtAAQgtAAggggg");
  	this.shape_14.setTransform(55.3,55.5);

  	this.shape_15 = new cjs.Shape();
  	this.shape_15.graphics.f("#A5A4A4").s().p("AieCfQhChCAAhdQAAhcBChCQBChCBcAAQBdAABCBCQBCBCAABcQAABdhCBCQhCBChdAAQhcAAhChCg");
  	this.shape_15.setTransform(55.1,55.5);

  	this.shape_16 = new cjs.Shape();
  	this.shape_16.graphics.f("#FFFFFF").s().p("AkDEEQgDgDAAgFQAAgEADgDQADgDAEgBQDNAACQiQQCRiQAAjNQAAgEADgDQADgDAEgBQAFABADADQADADAAAEQABDViXCXQiXCYjWAAQgEAAgDgEg");
  	this.shape_16.setTransform(80.3,80.5);

  	this.shape_17 = new cjs.Shape();
  	this.shape_17.graphics.f("#FFFFFF").s().p("AkEEFQgDgDAAgFQAAjVCYiYQCXiXDVAAQAEAAAEAEQADADAAAEQAAAEgDAEQgEADgEAAQjNAAiQCRQiRCQAADMQAAAFgDAEQgEADgEAAQgEAAgEgDg");
  	this.shape_17.setTransform(29.9,29.9);

  	this.shape_18 = new cjs.Shape();
  	this.shape_18.graphics.f("#414042").s().p("AmEGGQiiiiAAjkQAAjjCiihQChiiDjAAQDkAAChCiQCiChAADjQAADkiiCiQihChjkAAQjjAAihihgAlElDQiGCHAAC8QAAC+CGCGQCHCHC9AAQC+AACGiGQCHiHAAi+QAAi9iGiGQiHiHi+AAQi9AAiHCHg");
  	this.shape_18.setTransform(55.1,55.1);

  	this.shape_19 = new cjs.Shape();
  	this.shape_19.graphics.f("#FFFFFF").s().p("AlHFIQiJiIAAjAQAAi/CJiJQCHiIDAAAQDBAACICIQCICJAAC/QAADAiICIQiJCJjAAAQjAAAiHiJg");
  	this.shape_19.setTransform(55.1,55);

  	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_19},{t:this.shape_18},{t:this.shape_17},{t:this.shape_16},{t:this.shape_15},{t:this.shape_14},{t:this.shape_13},{t:this.shape_12},{t:this.shape_11},{t:this.shape_10},{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

  }).prototype = getMCSymbolPrototype(lib.Symbol8, new cjs.Rectangle(0,0,110.2,110.2), null);


  (lib.Symbol7 = function(mode: any, startPosition: any, loop: any) {
  	this.initialize(mode,startPosition,loop,{});

  	// Layer 1
  	this.shape = new cjs.Shape();
  	this.shape.graphics.f("#E6E7E8").s().p("Ag4A5QgXgYAAghQAAggAXgYQAYgXAgAAQAhAAAYAXQAXAYAAAgQAAAhgXAYQgYAXghAAQggAAgYgXg");
  	this.shape.setTransform(8,8);

  	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

  }).prototype = getMCSymbolPrototype(lib.Symbol7, new cjs.Rectangle(0,0,16,16), null);


  (lib.Symbol6 = function(mode: any, startPosition: any, loop: any) {
  	this.initialize(mode,startPosition,loop,{});

  	// Layer 1
  	this.shape = new cjs.Shape();
  	this.shape.graphics.f("#E6E7E8").s().p("Ag5A6QgZgYAAgiQAAghAZgZQAYgYAhAAQAiAAAZAYQAYAZAAAhQAAAigYAYQgZAZgiAAQghAAgYgZg");
  	this.shape.setTransform(53,8.3);

  	this.shape_1 = new cjs.Shape();
  	this.shape_1.graphics.f("#E6E7E8").s().p("Ag6A6QgYgYAAgiQAAghAYgZQAZgYAhAAQAiAAAZAYQAYAZAAAhQAAAigYAYQgZAZgiAAQghAAgZgZg");
  	this.shape_1.setTransform(43.3,14.6);

  	this.shape_2 = new cjs.Shape();
  	this.shape_2.graphics.f("#E6E7E8").s().p("Ag5A7QgZgZAAgiQAAgiAZgXQAYgZAhAAQAiAAAZAZQAYAXAAAiQAAAigYAZQgZAYgiAAQghAAgYgYg");
  	this.shape_2.setTransform(50,119.4);

  	this.shape_3 = new cjs.Shape();
  	this.shape_3.graphics.f("#E6E7E8").s().p("Ag5A7QgZgZAAgiQAAgiAZgXQAXgZAiAAQAiAAAZAZQAYAXAAAiQAAAigYAZQgZAYgiAAQgiAAgXgYg");
  	this.shape_3.setTransform(50.9,20.6);

  	this.shape_4 = new cjs.Shape();
  	this.shape_4.graphics.f("#E6E7E8").s().p("AhXBXQgkgkAAgzQAAgzAkgkQAlgkAyAAQAzAAAlAkQAkAkAAAzQAAAzgkAkQglAlgzAAQgyAAglglg");
  	this.shape_4.setTransform(67,14.6);

  	this.shape_5 = new cjs.Shape();
  	this.shape_5.graphics.f("#E6E7E8").s().p("AhWBYQglglAAgzQAAgyAlglQAkgkAyAAQAzAAAkAkQAlAlAAAyQAAAzglAlQgkAkgzAAQgyAAgkgkg");
  	this.shape_5.setTransform(28.3,16.5);

  	this.shape_6 = new cjs.Shape();
  	this.shape_6.graphics.f("#E6E7E8").s().p("Ag6A6QgYgYAAgiQAAghAYgZQAZgYAhAAQAiAAAZAYQAYAZAAAhQAAAigYAYQgZAZgiAAQghAAgZgZg");
  	this.shape_6.setTransform(28.3,52.5);

  	this.shape_7 = new cjs.Shape();
  	this.shape_7.graphics.f("#E6E7E8").s().p("AghAjQgPgOAAgVQAAgTAPgPQAOgOAUAAQAUAAAOAOQAOAPAAATQAAAVgOAOQgOAOgUAAQgUAAgOgOg");
  	this.shape_7.setTransform(59.2,124.3);

  	this.shape_8 = new cjs.Shape();
  	this.shape_8.graphics.f("#E6E7E8").s().p("Ag6A7QgYgZAAgiQAAghAYgZQAZgYAhAAQAiAAAZAYQAYAZAAAhQAAAigYAZQgZAYgiAAQghAAgZgYg");
  	this.shape_8.setTransform(28.3,87.2);

  	this.shape_9 = new cjs.Shape();
  	this.shape_9.graphics.f("#E6E7E8").s().p("Ag5A6QgZgYAAgiQAAghAZgZQAYgYAhAAQAiAAAZAYQAYAZAAAhQAAAigYAYQgZAZgiAAQghAAgYgZg");
  	this.shape_9.setTransform(20,44.3);

  	this.shape_10 = new cjs.Shape();
  	this.shape_10.graphics.f("#E6E7E8").s().p("Ag5A6QgZgYAAgiQAAgiAZgYQAYgYAhAAQAiAAAZAYQAYAYAAAiQAAAigYAYQgZAZgiAAQghAAgYgZg");
  	this.shape_10.setTransform(20,95.4);

  	this.shape_11 = new cjs.Shape();
  	this.shape_11.graphics.f("#E6E7E8").s().p("AhWBYQglglAAgzQAAgyAlglQAkgkAyAAQAzAAAkAkQAlAlAAAyQAAAzglAlQgkAkgzAAQgyAAgkgkg");
  	this.shape_11.setTransform(12.4,56.6);

  	this.shape_12 = new cjs.Shape();
  	this.shape_12.graphics.f("#E6E7E8").s().p("Ag6A7QgYgZAAgiQAAghAYgYQAZgZAhAAQAjAAAYAZQAYAYAAAhQAAAigYAZQgYAYgjAAQghAAgZgYg");
  	this.shape_12.setTransform(54.6,27.7);

  	this.shape_13 = new cjs.Shape();
  	this.shape_13.graphics.f("#E6E7E8").s().p("Ag6A7QgYgZAAgiQAAgiAYgXQAZgZAhAAQAiAAAYAZQAZAXAAAiQAAAigZAZQgYAYgiAAQghAAgZgYg");
  	this.shape_13.setTransform(42.7,119.4);

  	this.shape_14 = new cjs.Shape();
  	this.shape_14.graphics.f("#E6E7E8").s().p("Ag6A7QgYgZAAgiQAAghAYgZQAZgYAhAAQAiAAAZAYQAYAZAAAhQAAAigYAZQgZAYgiAAQghAAgZgYg");
  	this.shape_14.setTransform(24.8,64.7);

  	this.shape_15 = new cjs.Shape();
  	this.shape_15.graphics.f("#E6E7E8").s().p("AhXBYQgkglAAgzQAAgyAkglQAlgkAyAAQAzAAAlAkQAkAlAAAyQAAAzgkAlQglAkgzAAQgyAAglgkg");
  	this.shape_15.setTransform(21.1,76.6);

  	this.shape_16 = new cjs.Shape();
  	this.shape_16.graphics.f("#E6E7E8").s().p("Ah0B1QgwgxAAhEQAAhDAwgxQAwgwBEAAQBFAAAwAwQAwAxAABDQAABEgwAxQgwAwhFAAQhEAAgwgwg");
  	this.shape_16.setTransform(67,112.7);

  	this.shape_17 = new cjs.Shape();
  	this.shape_17.graphics.f("#E6E7E8").s().p("Ah0B0QgwgvAAhFQAAhDAwgxQAwgwBEAAQBEAAAwAwQAxAxAABDQAABFgxAvQgwAxhEAAQhEAAgwgxg");
  	this.shape_17.setTransform(36.5,36);

  	this.shape_18 = new cjs.Shape();
  	this.shape_18.graphics.f("#E6E7E8").s().p("Ah0B1QgwgxAAhEQAAhDAwgxQAxgwBDAAQBEAAAxAwQAwAxAABDQAABEgwAxQgxAwhEAAQhDAAgxgwg");
  	this.shape_18.setTransform(37,103.7);

  	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_18},{t:this.shape_17},{t:this.shape_16},{t:this.shape_15},{t:this.shape_14},{t:this.shape_13},{t:this.shape_12},{t:this.shape_11},{t:this.shape_10},{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

  }).prototype = getMCSymbolPrototype(lib.Symbol6, new cjs.Rectangle(0,0,83.5,129.2), null);


  // stage content:
  (lib.wheel = function(mode: any, startPosition: any, loop: any) {
  	this.initialize(mode,startPosition,loop,{});

  	// timeline functions:
  	this.frame_59 = function() {
  		this.gotoAndPlay(30);
  	}

  	// actions tween:
  	this.timeline.addTween(cjs.Tween.get(this).wait(59).call(this.frame_59).wait(1));

  	// Smoke-item-1 copy 9
  	this.instance = new lib.Symbol7();
  	this.instance.parent = this;
  	this.instance.setTransform(205.7,159.6,0.49,0.49,0,0,0,7.5,7.5);
  	this.instance.alpha = 0;
  	this.instance._off = true;

  	this.timeline.addTween(cjs.Tween.get(this.instance).wait(48).to({_off:false},0).wait(1).to({regX:8,regY:8,x:198,y:147.3,alpha:0.24},0).wait(1).to({x:190,y:134.8,alpha:0.48},0).wait(1).to({x:186.5,y:127.8,alpha:0.72},0).wait(1).to({scaleX:1.27,scaleY:1.27,x:183.3,y:121.2,alpha:0.96},0).wait(1).to({x:179.8,y:114.2,alpha:0.769},0).wait(1).to({x:176.7,y:111.3,alpha:0.578},0).wait(1).to({x:173.7,y:108.4,alpha:0.387},0).wait(1).to({x:170.7,y:105.6,alpha:0.195},0).wait(1).to({x:167.7,y:102.7,alpha:0.004},0).wait(3));

  	// Smoke-item-1 copy 10
  	this.instance_1 = new lib.Symbol7();
  	this.instance_1.parent = this;
  	this.instance_1.setTransform(193.1,138,0.49,0.49,0,0,0,7.5,7.5);
  	this.instance_1.alpha = 0;
  	this.instance_1._off = true;

  	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(24).to({_off:false},0).wait(1).to({regX:8,regY:8,x:190.6,y:134.9,alpha:0.074},0).wait(1).to({x:187.9,y:131.7,alpha:0.148},0).wait(1).to({x:185.2,y:128.4,alpha:0.222},0).wait(1).to({x:184.2,y:126.8,alpha:0.295},0).wait(1).to({x:183.1,y:125.2,alpha:0.369},0).wait(1).to({x:182,y:123.5,alpha:0.443},0).wait(1).to({x:180.9,y:121.9,alpha:0.517},0).wait(1).to({x:179.8,y:120.3,alpha:0.591},0).wait(1).to({x:178.7,y:118.7,alpha:0.665},0).wait(1).to({x:177.6,y:117,alpha:0.738},0).wait(1).to({scaleX:0.75,scaleY:0.75,x:176.7,y:115.6,alpha:0.812},0).wait(1).to({scaleX:1.01,scaleY:1.01,x:175.7,y:114.1,alpha:0.886},0).wait(1).to({scaleX:1.27,scaleY:1.27,x:175.1,y:112.8,alpha:0.96},0).wait(1).to({x:174.3,y:111.3,alpha:0.825},0).wait(1).to({x:173.6,y:109.9,alpha:0.689},0).wait(1).to({x:172.8,y:108.4,alpha:0.554},0).wait(1).to({x:172,y:107,alpha:0.418},0).wait(1).to({x:171.3,y:105.6,alpha:0.283},0).wait(1).to({x:170.5,y:104.1,alpha:0.148},0).wait(1).to({x:169.7,y:102.7,alpha:0.012},0).wait(16));

  	// Smoke-item-1 copy 11
  	this.instance_2 = new lib.Symbol7();
  	this.instance_2.parent = this;
  	this.instance_2.setTransform(170.6,215,0.49,0.49,0,0,0,7.5,7.5);
  	this.instance_2.alpha = 0;
  	this.instance_2._off = true;

  	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(49).to({_off:false},0).wait(1).to({regX:8,regY:8,x:141.7,y:202.2,alpha:0.117},0).wait(1).to({x:138.1,y:198.8,alpha:0.234},0).wait(1).to({x:134.5,y:195.4,alpha:0.351},0).wait(1).to({scaleX:0.65,scaleY:0.65,x:130.9,y:192,alpha:0.468},0).wait(1).to({scaleX:0.8,scaleY:0.8,x:128.9,y:190.2,alpha:0.585},0).wait(1).to({scaleX:0.96,scaleY:0.96,x:126.9,y:188.3,alpha:0.702},0).wait(1).to({scaleX:1.11,scaleY:1.11,x:124.9,y:186.4,alpha:0.82},0).wait(1).to({scaleX:1.27,scaleY:1.27,x:122.9,y:184.6,alpha:0.937},0).wait(1).to({x:120.8,y:182.6,alpha:0.471},0).wait(1).to({x:118.7,y:180.7,alpha:0.006},0).wait(1));

  	// Smoke-item-1 copy 12
  	this.instance_3 = new lib.Symbol7();
  	this.instance_3.parent = this;
  	this.instance_3.setTransform(185.5,235.3,0.506,0.487,0,0,0,7.4,7.4);
  	this.instance_3.alpha = 0.398;
  	this.instance_3._off = true;

  	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(49).to({_off:false},0).wait(1).to({regX:8,regY:8,scaleX:1.27,scaleY:1.27,x:162.2,y:230,alpha:0.94},0).wait(1).to({x:156.8,y:226.9,alpha:0.836},0).wait(1).to({x:151.3,y:223.9,alpha:0.732},0).wait(1).to({x:149.5,y:222.7,alpha:0.629},0).wait(1).to({x:147.7,y:221.6,alpha:0.525},0).wait(1).to({x:145.9,y:220.4,alpha:0.421},0).wait(1).to({x:144.1,y:219.2,alpha:0.317},0).wait(1).to({x:142.3,y:218.1,alpha:0.213},0).wait(1).to({x:140.5,y:216.9,alpha:0.11},0).wait(1).to({x:138.7,y:215.8,alpha:0.006},0).wait(1));

  	// Smoke-item-1 copy 14
  	this.instance_4 = new lib.Symbol7();
  	this.instance_4.parent = this;
  	this.instance_4.setTransform(185.5,235.3,0.506,0.487,0,0,0,7.4,7.4);
  	this.instance_4.alpha = 0.391;
  	this.instance_4._off = true;

  	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(44).to({_off:false},0).wait(1).to({regX:8,regY:8,scaleX:0.56,scaleY:0.55,x:177.8,y:233.6,alpha:0.459},0).wait(1).to({scaleX:0.62,scaleY:0.61,x:169.9,y:231.6,alpha:0.522},0).wait(1).to({scaleX:0.68,scaleY:0.67,x:161.9,y:229.7,alpha:0.585},0).wait(1).to({scaleX:0.74,scaleY:0.73,x:156.5,y:226.6,alpha:0.648},0).wait(1).to({scaleX:0.8,scaleY:0.79,x:151.1,y:223.6,alpha:0.711},0).wait(1).to({scaleX:0.86,scaleY:0.85,x:149.8,y:222.8,alpha:0.775},0).wait(1).to({scaleX:0.92,scaleY:0.91,x:148.6,y:222,alpha:0.838},0).wait(1).to({scaleX:0.98,scaleY:0.97,x:147.4,y:221.3,alpha:0.901},0).wait(1).to({scaleX:1.03,scaleY:1.03,x:146.2,y:220.5,alpha:0.964},0).wait(1).to({scaleX:1.09,scaleY:1.09,x:144.9,y:219.7,alpha:0.811},0).wait(1).to({scaleX:1.15,scaleY:1.15,x:143.7,y:219,alpha:0.659},0).wait(1).to({scaleX:1.21,scaleY:1.21,x:142.5,y:218.2,alpha:0.507},0).wait(1).to({scaleX:1.27,scaleY:1.27,x:141.3,y:217.4,alpha:0.355},0).wait(1).to({x:140,y:216.6,alpha:0.202},0).wait(1).to({x:138.7,y:215.8,alpha:0.05},0).wait(1));

  	// Smoke-item-1 copy 13
  	this.instance_5 = new lib.Symbol7();
  	this.instance_5.parent = this;
  	this.instance_5.setTransform(197.8,240.8,0.506,0.487,0,0,0,7.4,7.5);
  	this.instance_5.alpha = 0.68;
  	this.instance_5._off = true;

  	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(30).to({_off:false},0).wait(1).to({regX:8,regY:8,scaleX:0.57,scaleY:0.56,x:186.1,y:238,alpha:0.743},0).wait(1).to({scaleX:0.65,scaleY:0.63,x:174.2,y:235.1,alpha:0.807},0).wait(1).to({scaleX:0.71,scaleY:0.7,x:168.7,y:232,alpha:0.87},0).wait(1).to({scaleX:0.78,scaleY:0.77,x:163.3,y:229,alpha:0.933},0).wait(1).to({scaleX:0.85,scaleY:0.84,x:162,y:228.2,alpha:0.997},0).wait(1).to({scaleX:0.92,scaleY:0.91,x:160.7,y:227.3,alpha:0.873},0).wait(1).to({scaleX:0.99,scaleY:0.99,x:159.3,y:226.4,alpha:0.75},0).wait(1).to({scaleX:1.06,scaleY:1.06,x:157.9,y:225.5,alpha:0.627},0).wait(1).to({scaleX:1.13,scaleY:1.13,x:156.6,y:224.7,alpha:0.503},0).wait(1).to({scaleX:1.2,scaleY:1.2,x:155.2,y:223.8,alpha:0.38},0).wait(1).to({scaleX:1.27,scaleY:1.27,x:153.8,y:222.9,alpha:0.257},0).wait(1).to({x:152.4,y:222,alpha:0.133},0).wait(1).to({x:151,y:221.1,alpha:0.01},0).to({_off:true},1).wait(16));

  	// Wheel
  	this.instance_6 = new lib.Symbol8();
  	this.instance_6.parent = this;
  	this.instance_6.setTransform(215.6,189.6,1,1,0,0,0,55.1,55.1);

  	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(1).to({rotation:67.1,x:215.5,y:189.5},0).wait(1).to({rotation:134.2,x:215.4},0).wait(1).to({rotation:201.4,x:215.5},0).wait(1).to({rotation:268.5,x:215.6,y:189.4},0).wait(1).to({rotation:335.6,y:189.6},0).wait(1).to({rotation:402.7},0).wait(1).to({rotation:469.8,x:215.5,y:189.5},0).wait(1).to({rotation:536.9},0).wait(1).to({rotation:604.1,x:215.6,y:189.4},0).wait(1).to({rotation:671.2,y:189.5},0).wait(1).to({rotation:738.3},0).wait(1).to({rotation:805.4,x:215.5},0).wait(1).to({rotation:872.5},0).wait(1).to({rotation:939.7},0).wait(1).to({rotation:1006.8,x:215.6},0).wait(1).to({rotation:1073.9,y:189.6},0).wait(1).to({rotation:1141,x:215.5},0).wait(1).to({rotation:1208.1,x:215.4,y:189.5},0).wait(1).to({rotation:1275.3,x:215.5,y:189.4},0).wait(1).to({rotation:1342.4,x:215.6,y:189.5},0).wait(1).to({rotation:1409.5},0).wait(1).to({rotation:1476.6,y:189.6},0).wait(1).to({rotation:1543.7,x:215.4,y:189.5},0).wait(1).to({rotation:1610.8,x:215.5,y:189.4},0).wait(1).to({rotation:1678},0).wait(1).to({rotation:1745.1,x:215.6,y:189.5},0).wait(1).to({rotation:1812.2,y:189.6},0).wait(1).to({rotation:1879.3,x:215.5},0).wait(1).to({rotation:1946.4,y:189.5},0).wait(1).to({rotation:2013.6},0).wait(1).to({rotation:2080.7,x:215.6,y:189.4},0).wait(1).to({rotation:2147.8,y:189.5},0).wait(1).to({rotation:2214.9,x:215.5,y:189.6},0).wait(1).to({rotation:2282,y:189.5},0).wait(1).to({rotation:2349.2},0).wait(1).to({rotation:2416.3,x:215.6,y:189.4},0).wait(1).to({rotation:2483.4,y:189.5},0).wait(1).to({rotation:2550.5},0).wait(1).to({rotation:2617.6,x:215.5},0).wait(1).to({rotation:2684.7},0).wait(1).to({rotation:2751.9,y:189.4},0).wait(1).to({rotation:2819,x:215.6,y:189.5},0).wait(1).to({rotation:2886.1,y:189.6},0).wait(1).to({rotation:2953.2,x:215.5},0).wait(1).to({rotation:3020.3,y:189.5},0).wait(1).to({rotation:3087.5,y:189.4},0).wait(1).to({rotation:3154.6,x:215.6,y:189.5},0).wait(1).to({rotation:3221.7},0).wait(1).to({rotation:3288.8,y:189.6},0).wait(1).to({rotation:3355.9,x:215.5,y:189.5},0).wait(1).to({rotation:3423.1},0).wait(1).to({rotation:3490.2,x:215.6,y:189.4},0).wait(1).to({rotation:3557.3,y:189.5},0).wait(1).to({rotation:3624.4,y:189.6},0).wait(1).to({rotation:3691.5,x:215.5},0).wait(1).to({rotation:3758.6,y:189.5},0).wait(1).to({rotation:3825.8,x:215.6,y:189.4},0).wait(1).to({rotation:3892.9,y:189.5},0).wait(1).to({rotation:3960,y:189.6},0).wait(1));

  	// Smoke
  	this.instance_7 = new lib.Symbol6();
  	this.instance_7.parent = this;
  	this.instance_7.setTransform(178,181,0.008,0.008,180);
  	this.instance_7._off = true;

  	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(4).to({_off:false},0).wait(1).to({regX:41.8,regY:64.6,scaleX:0.04,scaleY:0.04,rotation:0,x:177.4,y:180.4,alpha:0},0).wait(1).to({scaleX:0.09,scaleY:0.09,x:177.1,alpha:0.042},0).wait(1).to({scaleX:0.14,scaleY:0.14,x:176.9,alpha:0.084},0).wait(1).to({scaleX:0.18,scaleY:0.18,x:176.7,alpha:0.126},0).wait(1).to({scaleX:0.23,scaleY:0.23,x:176.4,y:180.3,alpha:0.168},0).wait(1).to({scaleX:0.28,scaleY:0.28,x:176.2,y:180.4,alpha:0.21},0).wait(1).to({scaleX:0.33,scaleY:0.33,x:175.9,y:180.3,alpha:0.252},0).wait(1).to({scaleX:0.38,scaleY:0.38,x:175.7,alpha:0.294},0).wait(1).to({scaleX:0.42,scaleY:0.42,x:175.4,alpha:0.336},0).wait(1).to({scaleX:0.47,scaleY:0.47,x:175.2,alpha:0.378},0).wait(1).to({scaleX:0.52,scaleY:0.52,x:175,alpha:0.42},0).wait(1).to({scaleX:0.57,scaleY:0.57,x:174.7,y:180.2,alpha:0.462},0).wait(1).to({scaleX:0.62,scaleY:0.62,x:174.4,alpha:0.504},0).wait(1).to({scaleX:0.66,scaleY:0.66,x:174.2,alpha:0.546},0).wait(1).to({scaleX:0.71,scaleY:0.71,x:173.9,alpha:0.588},0).wait(1).to({scaleX:0.76,scaleY:0.76,x:173.7,y:180.1,alpha:0.63},0).wait(1).to({scaleX:0.81,scaleY:0.81,x:173.4,alpha:0.672},0).wait(1).to({scaleX:0.86,scaleY:0.86,x:173.2,alpha:0.714},0).wait(1).to({scaleX:0.9,scaleY:0.9,x:173,alpha:0.756},0).wait(1).to({scaleX:0.95,scaleY:0.95,x:172.7,alpha:0.798},0).wait(1).to({scaleX:1,scaleY:1,x:172.5,y:180,alpha:0.84},0).wait(35));

  	// Smoke-item-1 copy 2
  	this.instance_8 = new lib.Symbol7();
  	this.instance_8.parent = this;
  	this.instance_8.setTransform(173.9,166.5,0.49,0.49,0,0,0,8,8);
  	this.instance_8.alpha = 0.141;
  	this.instance_8._off = true;

  	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(8).to({_off:false},0).wait(1).to({y:166.4,alpha:0.377},0).wait(1).to({x:173.8,alpha:0.613},0).wait(1).to({alpha:0.85},0).wait(1).to({x:173.7,alpha:0.655},0).wait(1).to({y:166.3,alpha:0.46},0).wait(1).to({x:173.6,alpha:0.265},0).wait(1).to({alpha:0.07},0).wait(1).to({alpha:0.067},0).wait(1).to({x:173.5,alpha:0.064},0).wait(1).to({y:166.2,alpha:0.062},0).wait(1).to({x:173.4,alpha:0.059},0).wait(1).to({alpha:0.056},0).wait(1).to({x:173.3,alpha:0.053},0).wait(1).to({y:166.1,alpha:0.05},0).wait(1).to({alpha:0.048},0).wait(1).to({x:173.2,alpha:0.045},0).wait(1).to({alpha:0.042},0).wait(1).to({x:173.1,alpha:0.039},0).wait(1).to({y:166,alpha:0.036},0).wait(1).to({x:173,alpha:0.034},0).wait(1).to({scaleX:0.56,scaleY:0.56,alpha:0.031},0).wait(1).to({scaleX:0.63,scaleY:0.63,x:170.5,y:163.4,alpha:0.028},0).wait(1).to({scaleX:0.7,scaleY:0.71,x:168.1,y:160.8,alpha:0.025},0).wait(1).to({scaleX:0.78,scaleY:0.78,x:165.6,y:158.1,alpha:0.022},0).wait(1).to({scaleX:0.85,scaleY:0.85,x:163.2,y:155.6,alpha:0.02},0).wait(1).to({scaleX:0.92,scaleY:0.92,x:160.7,y:152.9,alpha:0.017},0).wait(1).to({scaleX:0.99,scaleY:0.99,x:158.2,y:150.3,alpha:0.014},0).wait(1).to({scaleX:1.06,scaleY:1.06,x:155.8,y:147.7,alpha:0.011},0).wait(1).to({scaleX:1.13,scaleY:1.14,x:153.3,y:145.1,alpha:0.008},0).wait(1).to({scaleX:1.2,scaleY:1.21,x:150.9,y:142.4,alpha:0.006},0).wait(1).to({scaleX:1.28,scaleY:1.28,x:148.4,y:139.8,alpha:0.003},0).wait(1).to({scaleX:1.35,scaleY:1.35,x:147,y:137.3,alpha:0},0).wait(1).to({scaleX:1.42,scaleY:1.42,x:145.6,y:134.7,alpha:0.425},0).wait(1).to({scaleX:1.49,scaleY:1.5,x:144.2,y:132.2,alpha:0.85},0).wait(1).to({scaleX:1.56,scaleY:1.57,x:142.8,y:129.6,alpha:0.756},0).wait(1).to({scaleX:1.63,scaleY:1.64,x:141.4,y:127.1,alpha:0.661},0).wait(1).to({scaleX:1.7,scaleY:1.71,x:140,y:124.5,alpha:0.567},0).wait(1).to({scaleX:1.78,scaleY:1.78,x:138.6,y:122,alpha:0.472},0).wait(1).to({scaleX:1.85,scaleY:1.85,x:137.2,y:119.4,alpha:0.378},0).wait(1).to({scaleX:1.92,scaleY:1.93,x:135.8,y:116.9,alpha:0.283},0).wait(1).to({scaleX:1.99,scaleY:2,x:134.4,y:114.3,alpha:0.189},0).wait(1).to({x:126.7,y:105.7,alpha:0.094},0).wait(1).to({x:119.1,y:97.1,alpha:0},0).wait(9));

  	// Smoke-item-1 copy 3
  	this.instance_9 = new lib.Symbol7();
  	this.instance_9.parent = this;
  	this.instance_9.setTransform(178.7,185,0.49,0.49,0,0,0,7.5,8);
  	this.instance_9.alpha = 0.141;
  	this.instance_9._off = true;

  	this.timeline.addTween(cjs.Tween.get(this.instance_9).wait(8).to({_off:false},0).wait(1).to({regX:8,x:178.9,alpha:0.377},0).wait(1).to({alpha:0.613},0).wait(1).to({alpha:0.85},0).wait(1).to({alpha:0.655},0).wait(1).to({alpha:0.46},0).wait(1).to({alpha:0.265},0).wait(1).to({alpha:0.07},0).wait(1).to({alpha:0.067},0).wait(1).to({alpha:0.064},0).wait(1).to({alpha:0.061},0).wait(1).to({alpha:0.058},0).wait(1).to({alpha:0.055},0).wait(1).to({alpha:0.052},0).wait(1).to({alpha:0.049},0).wait(1).to({alpha:0.046},0).wait(1).to({alpha:0.043},0).wait(1).to({alpha:0.04},0).wait(1).to({alpha:0.037},0).wait(1).to({alpha:0.033},0).wait(1).to({x:175.8,y:182.7,alpha:0.03},0).wait(1).to({scaleX:0.57,scaleY:0.57,x:172.8,y:180.4,alpha:0.027},0).wait(1).to({scaleX:0.65,scaleY:0.65,x:169.8,y:178,alpha:0.024},0).wait(1).to({scaleX:0.73,scaleY:0.73,x:166.7,y:175.7,alpha:0.021},0).wait(1).to({scaleX:0.81,scaleY:0.81,x:163.7,y:173.4,alpha:0.018},0).wait(1).to({scaleX:0.89,scaleY:0.89,x:160.7,y:171,alpha:0.015},0).wait(1).to({scaleX:0.96,scaleY:0.97,x:157.6,y:168.7,alpha:0.012},0).wait(1).to({scaleX:1.04,scaleY:1.05,x:154.6,y:166.4,alpha:0.009},0).wait(1).to({scaleX:1.12,scaleY:1.12,x:151.5,y:164.1,alpha:0.006},0).wait(1).to({scaleX:1.2,scaleY:1.2,x:148.5,y:161.7,alpha:0.003},0).wait(1).to({scaleX:1.28,scaleY:1.28,x:147.3,y:159.3,alpha:0},0).wait(1).to({scaleX:1.36,scaleY:1.36,x:146.1,y:156.9,alpha:0.425},0).wait(1).to({scaleX:1.44,scaleY:1.44,x:144.9,y:154.4,alpha:0.85},0).wait(1).to({scaleX:1.52,scaleY:1.52,x:143.8,y:152,alpha:0.756},0).wait(1).to({scaleX:1.6,scaleY:1.6,x:142.5,y:149.6,alpha:0.661},0).wait(1).to({scaleX:1.67,scaleY:1.68,x:141.4,y:147.2,alpha:0.567},0).wait(1).to({scaleX:1.75,scaleY:1.76,x:140.2,y:144.7,alpha:0.472},0).wait(1).to({scaleX:1.83,scaleY:1.84,x:139,y:142.3,alpha:0.378},0).wait(1).to({scaleX:1.91,scaleY:1.92,x:137.8,y:139.9,alpha:0.283},0).wait(1).to({scaleX:1.99,scaleY:2,x:136.6,y:137.4,alpha:0.189},0).wait(1).to({x:135.4,y:135,alpha:0.094},0).wait(1).to({x:127.7,y:130,alpha:0},0).wait(1).to({x:120.1,y:125.1},0).wait(10));

  	// Smoke-item-1 copy 5
  	this.instance_10 = new lib.Symbol7();
  	this.instance_10.parent = this;
  	this.instance_10.setTransform(178.7,185,0.49,0.49,0,0,0,7.5,8);
  	this.instance_10.alpha = 0;
  	this.instance_10._off = true;

  	this.timeline.addTween(cjs.Tween.get(this.instance_10).wait(16).to({_off:false},0).wait(1).to({regX:8,x:178.9},0).wait(2).to({x:178.8},0).wait(4).to({x:178.7},0).wait(4).to({x:178.6},0).wait(4).to({x:178.5},0).wait(4).to({x:178.4},0).wait(4).to({x:178.3},0).wait(3).to({alpha:0.091},0).wait(1).to({x:178.2,alpha:0.183},0).wait(1).to({x:173.7,y:179.8,alpha:0.274},0).wait(1).to({x:169.1,y:174.6,alpha:0.366},0).wait(1).to({x:164.5,y:169.4,alpha:0.457},0).wait(1).to({scaleX:0.68,scaleY:0.68,x:160.1,y:164.2,alpha:0.549},0).wait(1).to({scaleX:0.86,scaleY:0.86,x:155.6,y:159,alpha:0.64},0).wait(1).to({scaleX:1.05,scaleY:1.05,x:151.1,y:153.9,alpha:0.731},0).wait(1).to({scaleX:1.24,scaleY:1.24,x:146.7,y:148.7,alpha:0.823},0).wait(1).to({scaleX:1.42,scaleY:1.42,x:142.2,y:143.4,alpha:0.736},0).wait(1).to({scaleX:1.61,scaleY:1.61,x:137.7,y:138.3,alpha:0.649},0).wait(1).to({scaleX:1.79,scaleY:1.79,x:133.3,y:133.1,alpha:0.562},0).wait(1).to({scaleX:1.98,scaleY:1.98,x:130.1,y:130.6,alpha:0.475},0).wait(1).to({scaleX:1.98,x:126.7,y:128.1,alpha:0.388},0).wait(1).to({scaleX:1.98,x:123.4,y:125.6,alpha:0.302},0).wait(1).to({scaleX:1.99,x:120.1,y:123.1,alpha:0.201},0).wait(1).to({scaleX:1.99,x:116.8,y:120.6,alpha:0.101},0).wait(1).to({scaleX:1.99,x:113.5,y:118.1,alpha:0},0).wait(1));

  	// Smoke-item-1 copy 6
  	this.instance_11 = new lib.Symbol7();
  	this.instance_11.parent = this;
  	this.instance_11.setTransform(178.7,185,0.49,0.49,0,0,0,7.5,8);
  	this.instance_11.alpha = 0;
  	this.instance_11._off = true;

  	this.timeline.addTween(cjs.Tween.get(this.instance_11).wait(16).to({_off:false},0).wait(1).to({regX:8,x:178.9},0).wait(1).to({x:178.8},0).wait(2).to({x:178.7},0).wait(2).to({x:178.6},0).wait(2).to({x:178.5},0).wait(2).to({x:178.4},0).wait(2).to({x:178.3},0).wait(2).to({x:178.2},0).wait(1).to({x:175.2,y:181.3},0).wait(1).to({scaleX:0.6,scaleY:0.6,x:172.2,y:177.6,alpha:0.069},0).wait(1).to({scaleX:0.7,scaleY:0.7,x:169.2,y:173.9,alpha:0.137},0).wait(1).to({scaleX:0.81,scaleY:0.81,x:166.2,y:170.2,alpha:0.206},0).wait(1).to({scaleX:0.92,scaleY:0.92,x:163.3,y:166.5,alpha:0.274},0).wait(1).to({scaleX:1.02,scaleY:1.02,x:160.3,y:162.8,alpha:0.343},0).wait(1).to({scaleX:1.13,scaleY:1.13,x:157.3,y:159.1,alpha:0.411},0).wait(1).to({scaleX:1.24,scaleY:1.24,x:154.3,y:155.4,alpha:0.48},0).wait(1).to({scaleX:1.34,scaleY:1.34,x:151.3,y:151.7,alpha:0.549},0).wait(1).to({scaleX:1.45,scaleY:1.45,x:148.3,y:147.9,alpha:0.617},0).wait(1).to({scaleX:1.55,scaleY:1.55,x:145.3,y:144.2,alpha:0.686},0).wait(1).to({scaleX:1.66,scaleY:1.66,x:142.3,y:140.5,alpha:0.754},0).wait(1).to({scaleX:1.77,scaleY:1.77,x:139.4,y:136.8,alpha:0.823},0).wait(1).to({scaleX:1.87,scaleY:1.87,x:136.4,y:133.1,alpha:0.761},0).wait(1).to({scaleX:1.98,scaleY:1.98,x:134.9,y:132.1,alpha:0.699},0).wait(1).to({x:133.3,y:131.1,alpha:0.638},0).wait(1).to({x:131.8,y:130.1,alpha:0.576},0).wait(1).to({x:130.2,y:129.1,alpha:0.514},0).wait(1).to({x:128.6,y:128.1,alpha:0.452},0).wait(1).to({x:127.1,y:127.1,alpha:0.391},0).wait(1).to({x:125.5,y:126.1,alpha:0.329},0).wait(1).to({x:124,y:125.1,alpha:0.267},0).wait(1).to({x:122.4,y:124.1,alpha:0.205},0).wait(1).to({x:120.9,y:123.1,alpha:0.144},0).wait(1).to({x:119.3,y:122.1,alpha:0.082},0).wait(1).to({x:117.8,y:121.1,alpha:0.02},0).wait(1).to({x:116.2,y:120.1},0).wait(1).to({x:114.7,y:119.1},0).wait(1).to({x:113.1,y:118.1},0).wait(1));

  	// Smoke-item-1 copy 7
  	this.instance_12 = new lib.Symbol7();
  	this.instance_12.parent = this;
  	this.instance_12.setTransform(193.8,217.2,0.49,0.49,0,0,0,7.5,7.5);
  	this.instance_12.alpha = 0;
  	this.instance_12._off = true;

  	this.timeline.addTween(cjs.Tween.get(this.instance_12).wait(36).to({_off:false},0).wait(1).to({regX:8,regY:8,x:186,y:211.6},0).wait(1).to({x:177.9,y:205.8},0).wait(1).to({x:169.8,y:200},0).wait(1).to({x:161.7,y:194.2},0).wait(1).to({x:158.3,y:191.7},0).wait(1).to({scaleX:0.75,scaleY:0.75,x:155,y:189.4,alpha:0.165},0).wait(1).to({scaleX:1.01,scaleY:1.01,x:151.7,y:187.1,alpha:0.329},0).wait(1).to({scaleX:1.27,scaleY:1.27,x:148.4,y:184.7,alpha:0.494},0).wait(1).to({x:145,y:182.2,alpha:0.658},0).wait(1).to({x:141.5,y:179.7,alpha:0.823},0).wait(1).to({x:138.1,y:177.2,alpha:0.75},0).wait(1).to({x:134.7,y:174.7,alpha:0.677},0).wait(1).to({x:133.1,y:172.1,alpha:0.604},0).wait(1).to({x:131.4,y:169.6,alpha:0.531},0).wait(1).to({x:129.8,y:167.1,alpha:0.458},0).wait(1).to({x:128.2,y:164.5,alpha:0.385},0).wait(1).to({x:126.6,y:162,alpha:0.312},0).wait(1).to({x:124.9,y:159.5,alpha:0.239},0).wait(1).to({x:123.3,y:156.9,alpha:0.166},0).wait(1).to({x:121.7,y:154.4,alpha:0.093},0).wait(1).to({alpha:0.02},0).wait(3));

  	// Smoke-item-1 copy 8
  	this.instance_13 = new lib.Symbol7();
  	this.instance_13.parent = this;
  	this.instance_13.setTransform(193.8,217.2,0.49,0.49,0,0,0,7.5,7.5);
  	this.instance_13.alpha = 0;
  	this.instance_13._off = true;

  	this.timeline.addTween(cjs.Tween.get(this.instance_13).wait(36).to({_off:false},0).wait(1).to({regX:8,regY:8,x:186,y:211.6},0).wait(1).to({x:177.9,y:205.8},0).wait(1).to({x:169.8,y:200},0).wait(1).to({x:161.7,y:194.2},0).wait(1).to({x:158.3,y:191.7},0).wait(1).to({scaleX:0.75,scaleY:0.75,x:155,y:189.4,alpha:0.165},0).wait(1).to({scaleX:1.01,scaleY:1.01,x:151.7,y:187.1,alpha:0.329},0).wait(1).to({scaleX:1.27,scaleY:1.27,x:148.4,y:184.7,alpha:0.494},0).wait(1).to({x:145,y:182.2,alpha:0.658},0).wait(1).to({x:141.5,y:179.7,alpha:0.823},0).wait(1).to({x:138.1,y:177.2,alpha:0.75},0).wait(1).to({x:134.7,y:174.7,alpha:0.677},0).wait(1).to({x:133.1,y:172.1,alpha:0.604},0).wait(1).to({x:131.4,y:169.6,alpha:0.531},0).wait(1).to({x:129.8,y:167.1,alpha:0.458},0).wait(1).to({x:128.2,y:164.5,alpha:0.385},0).wait(1).to({x:126.6,y:162,alpha:0.312},0).wait(1).to({x:124.9,y:159.5,alpha:0.239},0).wait(1).to({x:123.3,y:156.9,alpha:0.166},0).wait(1).to({x:121.7,y:154.4,alpha:0.093},0).wait(1).to({alpha:0.02},0).wait(3));

  	// Smoke-item-1 copy
  	this.instance_14 = new lib.Symbol7();
  	this.instance_14.parent = this;
  	this.instance_14.setTransform(178,185,0.49,0.49,0,0,0,7.5,8);
  	this.instance_14.alpha = 0;
  	this.instance_14._off = true;

  	this.timeline.addTween(cjs.Tween.get(this.instance_14).wait(19).to({_off:false},0).wait(1).to({regX:8,x:178.2,alpha:0.165},0).wait(1).to({x:172.1,y:178.6,alpha:0.329},0).wait(1).to({x:166,y:172.1,alpha:0.494},0).wait(1).to({scaleX:0.86,scaleY:0.86,x:160.2,y:165.7,alpha:0.658},0).wait(1).to({scaleX:1.23,scaleY:1.24,x:154.3,y:159.3,alpha:0.823},0).wait(1).to({scaleX:1.6,scaleY:1.61,x:148.5,y:154.9,alpha:0.662},0).wait(1).to({scaleX:1.97,scaleY:1.98,x:142.8,y:150.4,alpha:0.502},0).wait(1).to({x:136.9,y:146,alpha:0.341},0).wait(1).to({x:130.9,y:141.6,alpha:0.181},0).wait(1).to({x:125,y:137.1,alpha:0.02},0).wait(31));

  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(310.5,284.5,110.1,110.2);
  // library properties:
  lib.properties = {
  	id: 'E92A82A681754F40A1C2DF8649335BAB',
  	width: 300,
  	height: 300,
  	fps: 24,
  	color: "#FFFFFF",
  	opacity: 1.00,
  	webfonts: {},
  	manifest: [],
  	preloads: []
  };



  // bootstrap callback support:

  (lib.Stage = function(canvas: any) {
  	cjs.Stage.call(this, canvas);
  }).prototype = p = new cjs.Stage();

  p.setAutoPlay = function(autoPlay: any) {
  	this.tickEnabled = autoPlay;
  }
  p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
  p.stop = function(ms: any) { if(ms) this.seek(ms); this.tickEnabled = false; }
  p.seek = function(ms: any) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
  p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

  p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

  an.bootcompsLoaded = an.bootcompsLoaded || [];
  if(!an.bootstrapListeners) {
  	an.bootstrapListeners=[];
  }

  an.bootstrapCallback=function(fnCallback: any) {
  	an.bootstrapListeners.push(fnCallback);
  	if(an.bootcompsLoaded.length > 0) {
  		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
  			fnCallback(an.bootcompsLoaded[i]);
  		}
  	}
  };

  an.compositions = an.compositions || {};
  an.compositions['E92A82A681754F40A1C2DF8649335BAB'] = {
  	getStage: function() { return exportRoot.getStage(); },
  	getLibrary: function() { return lib; },
  	getSpriteSheet: function() { return ss; },
  	getImages: function() { return img; }
  };

  an.compositionLoaded = function(id: any) {
  	an.bootcompsLoaded.push(id);
  	for(var j=0; j<an.bootstrapListeners.length; j++) {
  		an.bootstrapListeners[j](id);
  	}
  }

  an.getComposition = function(id: any) {
  	return an.compositions[id];
  }

};

/* eslint-enable */
